module.exports = __webpack_public_path__ + "static/media/beard-background.0788bdb4.jpg";